module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Medium.f1d8d113.eot";